const MAX_FETCH_ATTEMPTS = 4;
const sleep = (ms) => new Promise(r => setTimeout(r, ms));

export async function fetchItem(category, attempt = 0) {
  const qs = category && category !== "All" ? `?category=${encodeURIComponent(category)}` : "";
  let res;
  try {
    res = await fetch("/api/item" + qs, { cache: "no-store" });
  } catch (e) {
    if (attempt < MAX_FETCH_ATTEMPTS - 1) {
      await sleep(400 * (attempt + 1));
      return fetchItem(category, attempt + 1);
    }
    throw new Error("Network error — please try again");
  }
  if (!res.ok) {
    if (attempt < MAX_FETCH_ATTEMPTS - 1) {
      await sleep(400 * (attempt + 1));
      return fetchItem(category, attempt + 1);
    }
    let msg = "Could not load an item — please try again";
    try {
      const body = await res.json();
      msg = body.error || body.message || msg;
    } catch {}
    throw new Error(msg);
  }
  try {
    return await res.json();
  } catch {
    if (attempt < MAX_FETCH_ATTEMPTS - 1) {
      await sleep(400 * (attempt + 1));
      return fetchItem(category, attempt + 1);
    }
    throw new Error("Invalid server response");
  }
}

export async function fetchImages(id) {
  try {
    const r = await fetch(`/api/images/${encodeURIComponent(id)}`);
    if (!r.ok) return [];
    const { images } = await r.json();
    return images || [];
  } catch {
    return [];
  }
}

export async function fetchCategories() {
  const r = await fetch("/api/categories", { cache: "no-store" });
  const { categories } = await r.json();
  return categories;
}
